/**
 * Consumption Calculator Component
 *
 */
var calculator_event_completed = false;
var consumption_calculator = document.getElementById("consumption_calculator");

var can_calculate = false;

if(consumption_calculator) {
  var consumption_calculator_calculated = document.getElementById("consumption_calculator_calculated");
  var consumption_calculator_notice = document.getElementById("consumption_calculator_notice");
  var consumption_calculator_answer = document.getElementById("consumption_calculator_answer");
  var consumption_calculator_length = document.getElementById("consumption_calculator").length;
  var consumption_calculator_width = document.getElementById("consumption_calculator").width;
  var consumption_calculator_depth = document.getElementById("consumption_calculator").depth;
  var consumption_calculator_unit = document.getElementById("consumption_calculator").unit;
  var consumption_calculator_type = document.getElementById("consumption_calculator").type;
  var consumption_calculator_amount = document.getElementById("consumption_calculator").consumption;

}

function construct_missing_notice() {
  var notice;
  let missing = [];

  if(consumption_calculator_type.value == 'volume' && (consumption_calculator_depth.value == 0 || consumption_calculator_depth.value == '')) {
    missing.push('syvyys');
  }
  if(consumption_calculator_length.value == 0 || consumption_calculator_length.value == '') {
    missing.push('pituus');
  }
  if(consumption_calculator_width.value == 0 || consumption_calculator_width.value == '') {
    missing.push('leveys');
  }

  notice = gc_strings.before_missing + ' ';
  missing.forEach(function(item, index) {
    if (item == 'syvyys') {
      notice += gc_strings.depth;
    } else if (item == 'pituus') {
      notice += gc_strings.length;
    } else if (item == 'leveys') {
      notice += gc_strings.width;
    }

    if (missing.length >= 2 && index == missing.length-2) {
      notice += ' ' + gc_strings.and + ' ';
    } else if (index != missing.length-1) {
      notice += ', ';
    } else {
      notice += ' ';
    }
  });
  notice += gc_strings.after_missing;

  if(missing.length == 0) {
    can_calculate = true;
  } else {
    can_calculate = false;
  }

  return notice;
}
if (consumption_calculator) {
  consumption_calculator_notice.innerHTML = construct_missing_notice();
}

function consumption_submit() {

  consumption_calculator_notice.innerHTML = construct_missing_notice();

  if(can_calculate) {
    consumption_calculator_calculated.classList.add('active');
    consumption_calculator_notice.classList.remove('active');

    if (consumption_calculator_type.value == 'volume') {
      var raw_volume = consumption_calculator_length.value * consumption_calculator_width.value * consumption_calculator_depth.value * 0.01;
      var density = consumption_calculator.density.value;
      if(consumption_calculator_unit.value == 'L') {
        var volume = Math.round((raw_volume * 1000) * 100) / 100;
        consumption_calculator_answer.innerHTML = volume + 'L';
        if (volume > 999.9) {
          volume = Math.round( raw_volume * 10) / 10;
          consumption_calculator_answer.innerHTML = volume + 'm³';
        } else if (volume > 1) {
          volume = Math.round((raw_volume * 1000)* 10) / 10;
        }
      } else if(consumption_calculator_unit.value == 'Kg') {
        var weight = Math.round( raw_volume * density * 10) / 10;
        consumption_calculator_answer.innerHTML = weight + 'kg';
      }
    } else {
      var raw_area_consumption = consumption_calculator_length.value * consumption_calculator_width.value * consumption_calculator_amount.value;
      var area_consumption = Math.round((raw_area_consumption) * 100) / 100;

      if(consumption_calculator_unit.value == 'L') {
        consumption_calculator_answer.innerHTML = area_consumption + 'L';
      } else {
        consumption_calculator_answer.innerHTML = area_consumption + 'kg';
      }
    }





  } else {
    consumption_calculator_notice.classList.add('active');
    consumption_calculator_calculated.classList.remove('active');
  }

  // track events
  if (calculator_event_completed == false) {
    if (window.ga && ga.loaded) {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Menekkilaskuri',
        eventAction: 'täytetty',
        eventLabel: document.title
      });
      calculator_event_completed = true;
    }
  }

}

function check_value(input) {
  if(input.value < 0 && input.value != '') {
    input.value = '';
  }
}

if(consumption_calculator) {
  consumption_calculator_length.addEventListener("keyup", function(event) {
    event.preventDefault();
    consumption_submit();
  });
  consumption_calculator_length.addEventListener("change", function(event) {
    event.preventDefault();
    check_value(consumption_calculator_length);
    if (consumption_calculator_length.value == '' || consumption_calculator_length.value == 0) {
      consumption_calculator_length.value = '';
    } else {
      consumption_calculator_length.value = Math.round(consumption_calculator_length.value*100)/100;
    }
    consumption_submit();
  });

  consumption_calculator_width.addEventListener("keyup", function(event) {
    event.preventDefault();
    check_value(consumption_calculator_width);
    consumption_submit();
  });
  consumption_calculator_width.addEventListener("change", function(event) {
    event.preventDefault();
    check_value(consumption_calculator_width);
    if (consumption_calculator_width.value == '' || consumption_calculator_width.value == 0) {
      consumption_calculator_width.value = '';
    } else {
      consumption_calculator_width.value = Math.round(consumption_calculator_width.value*100)/100;
    }
    consumption_submit();
  });

  consumption_calculator_depth.addEventListener("keyup", function(event) {
    event.preventDefault();
    check_value(consumption_calculator_depth);
    consumption_submit();
  });
  consumption_calculator_depth.addEventListener("change", function(event) {
    event.preventDefault();
    check_value(consumption_calculator_depth);
    if (consumption_calculator_depth.value == '' || consumption_calculator_depth.value == 0) {
      consumption_calculator_depth.value = '';
    } else {
      consumption_calculator_depth.value = Math.round(consumption_calculator_depth.value*100)/100;
    }
    consumption_submit();
  });

  consumption_calculator.addEventListener("submit", function(event) {
    event.preventDefault();
    //consumption_submit(consumption_calculator_length.value, consumption_calculator_width.value, consumption_calculator_depth.value);
  });
}
